/** Dependency-free language contract used by storage schemas and UI code. */
export const USER_LANGUAGES = ['ru', 'uz'] as const
export type UserLanguage = (typeof USER_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: UserLanguage = 'ru'

export function isUserLanguage(value: unknown): value is UserLanguage {
	return typeof value === 'string' && USER_LANGUAGES.includes(value as UserLanguage)
}
